import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { TableJobsOverview } from './TableJobsOverview';

const HelperText = observer(
  ({
    renderType = 'table',
    data = [],
    customMessage = 'Too many results detected, please update your filters accordingly.',
  }: {
    renderType?: string;
    data: any;
    customMessage?: string;
  }) => {
    if (!data || data.length === 0) {
      return null;
    }
    const modifyedData = data.map((item: any) => {
      return {
        'Input paths': item,
      };
    });
    const getHelperText = (type: string, tableData: any) => {
      switch (type) {
        case 'table':
          return <TableJobsOverview data={tableData} showCopyButton={false} />;
        default:
          return '';
      }
    };

    return (
      <Box sx={{ width: '100%' }}>
        <Typography sx={{ color: 'red', mb: 1 }}>{customMessage}</Typography>
        {getHelperText(renderType, modifyedData)}
      </Box>
    );
  }
);

export default HelperText;
